const getEnvironmentVar = (kay) => {
  const fylKey = `REACT_APP_${kay}`;
  if (fylKey in process.env) {
    return process.env[fylKey];
  }
  throw new Error("no key in the evt");
};

const config = {
  myGeolocation: getEnvironmentVar("MY_GEOLOCATION"),
  openweathermapKey: getEnvironmentVar("OPENWEATHERMAP_KEY"),
  weatherbitHourlyUrl: getEnvironmentVar("WEATHERBIT_HOURLY_URL"),
  weatherbitDailyUrl: getEnvironmentVar("WEATHERBIT_DAILY_URL"),
  unsplashUrl: getEnvironmentVar("UNSPLASH_URL"),
  forwardUrl: getEnvironmentVar("FORWARD_URL"),
  reverseUrl: getEnvironmentVar("REVERSE_URL"),
  token: getEnvironmentVar("MAPBOXGL_TOKEN"),
  translate: getEnvironmentVar("TRANSLATE"),
};

export default config;
